import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { ProblemSection } from '../components/sections/ProblemSection';
import { PromiseSection } from '../components/sections/PromiseSection';
import { MechanismSection } from '../components/sections/MechanismSection';
import { FilterSection } from '../components/sections/FilterSection';
import { OfferStackSection } from '../components/sections/OfferStackSection';
import { TestimonialsSection } from '../components/sections/TestimonialsSection';
import { HowItWorksSection } from '../components/sections/HowItWorksSection';
import { GuaranteeSection } from '../components/sections/GuaranteeSection';
import { PricingSection } from '../components/sections/PricingSection';
import { FAQSection } from '../components/sections/FAQSection';
import { FinalCTASection } from '../components/sections/FinalCTASection';
import { StickyMobileCTA } from '../components/ui/StickyMobileCTA';
export function LandingPage() {
  return <div className="min-h-screen bg-bg-primary text-text-primary font-body selection:bg-cta-primary selection:text-cta-text" data-id="element-300">
      <HeroSection data-id="element-301" />
      <ProblemSection data-id="element-302" />
      <PromiseSection data-id="element-303" />
      <MechanismSection data-id="element-304" />
      <FilterSection data-id="element-305" />
      <OfferStackSection data-id="element-306" />
      <TestimonialsSection data-id="element-307" />
      <HowItWorksSection data-id="element-308" />
      <GuaranteeSection data-id="element-309" />
      <PricingSection data-id="element-310" />
      <FAQSection data-id="element-311" />
      <FinalCTASection data-id="element-312" />

      {/* Footer simple */}
      <footer className="py-8 text-center text-text-secondary text-sm bg-bg-primary border-t border-border-color" data-id="element-313">
        <p data-id="element-314">
          © {new Date().getFullYear()} El Método Magnético. Todos los derechos
          reservados.
        </p>
      </footer>

      <StickyMobileCTA data-id="element-315" />
    </div>;
}